import React, { useContext } from 'react';
import cx from 'classnames';
import { TranslatorContext } from '@jutro/locale';
import styles from "./ProgressStep.module.css";
import { IconButton } from '../../IconButton/IconButton';
export const ProgressStep = ({
  id,
  step,
  className,
  isVertical
}) => {
  const translator = useContext(TranslatorContext);
  const visited = step.visited,
    active = step.active,
    title = step.title,
    onClick = step.onClick,
    _step$disabled = step.disabled,
    disabled = _step$disabled === void 0 ? false : _step$disabled;
  const progressStepClasses = cx(styles.progressStep, className, {
    [styles.active]: active,
    [styles.visited]: visited,
    [styles.vertical]: isVertical
  });
  const beforeConnectorClasses = cx(styles.markersConnector, styles.beforeConnector);
  const afterConnectorClasses = cx(styles.markersConnector, styles.afterConnector);
  return React.createElement("div", {
    className: progressStepClasses,
    onClick: onClick,
    onKeyPress: e => e.key === 'Enter' && (onClick === null || onClick === void 0 ? void 0 : onClick(e)),
    tabIndex: 0,
    role: "link",
    id: id
  }, React.createElement("div", null, React.createElement("div", {
    className: beforeConnectorClasses
  }), React.createElement(IconButton, {
    tabIndex: -1,
    disabled: disabled,
    className: styles.progressMarker,
    icon: "mi-check",
    iconClassName: styles.progressMarkerIcon
  }), React.createElement("div", {
    className: afterConnectorClasses
  })), React.createElement("div", {
    className: styles.title
  }, title ? translator(title) : ' '));
};
ProgressStep.__docgenInfo = {
  componentName: "ProgressStep",
  packageName: "@jutro/components",
  description: "",
  displayName: "ProgressStep",
  methods: [],
  actualName: "ProgressStep"
};